import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation {
        system_send_video_health_email_to_admins {
            success
        }
    }
`;

export async function runVideoHealthCheck(): Promise<boolean> {
    const result: FetchResult<{ system_send_video_health_email_to_admins: boolean }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: {},
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.system_send_video_health_email_to_admins;
}
